var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 102,
    viewBox: "0 0 166 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1549 90.0081H26.0438V95.2041H49.1549V90.0081Z",
    fill: "#27869F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.483 90.0082H116.372V95.2042H139.483V90.0082Z",
    fill: "#27869F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5564 0H146.97C150.146 0 152.723 2.57774 152.723 5.75288V87.4035C152.723 90.5787 150.146 93.1564 146.97 93.1564H18.5564C15.3813 93.1564 12.8035 90.5787 12.8035 87.4035V5.75288C12.8035 2.57774 15.3813 0 18.5564 0Z",
    fill: "#27869F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.138 7.52237H19.3894V85.6326H146.138V7.52237Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.931 94.2057L102.323 95.6237C102.138 96.0543 101.714 96.3337 101.245 96.3337H64.2877C63.8207 96.3337 63.3977 96.0563 63.2123 95.6278L62.5964 94.2064H0C0 98.5111 3.48963 102 7.79365 102H157.733C162.038 102 165.527 98.5105 165.527 94.2064H102.93L102.931 94.2057Z",
    fill: "#27869F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.a9e2f8ac37188c883b63d1611fadaf8d.svg";
export { ForwardRef as ReactComponent };